<template>
  <div class="flex w-full h-full justify-items-center items-center">
    <button
      class="button color-type-normal size-md"
      :class="buttonClass"
      @click="onClickEdit"
    >
      <div class="button-content">
        <vs-icon class="button-icon" icon-pack="feather" icon="edit" />
        <span class="button-label">{{ buttonLabel }}</span>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: "CellRendererActions",
  computed: {
    buttonLabel() {
      if (!this.params || !this.params.data) return "";
      const isClosed = this.params.data.isClosed;
      return isClosed ? "引戻し" : "締め";
    },
    buttonClass() {
      if (!this.params || !this.params.data) return "type-filled";
      const isClosed = this.params.data.isClosed;
      return isClosed ? "type-border" : "type-filled";
    },
  },
  methods: {
    onClickEdit() {
      this.params.onClickEdit(this.params.data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.button {
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: transparent;

  /* size */
  &.size-md {
    width: 70px;
    height: 32px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .button-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .button-icon {
    font-size: 18px;
  }

  .button-label {
    white-space: nowrap;
  }

  &.type-filled {
    border: none;

    &.color-type-normal {
      background-color: $aisea-blue;
      color: #ffffff;

      &:hover:not(:disabled) {
        background-color: darken($aisea-blue, 10%);
      }
    }
  }

  &.type-border {
    background-color: transparent;

    &.color-type-normal {
      border: 1px solid $aisea-blue;
      color: $aisea-blue;

      &:hover:not(:disabled) {
        background-color: rgba($aisea-blue, 0.1);
      }
    }
  }
}
</style>
